import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  resource: { companyResources : url },
} = config.endpoints

const post = (data) => axios.post(url, data, { headers: getHeaders(true) })
const get = (brands, delegations) =>
  axios({
    method: 'get',
    url: url + '?brands=' + brands + '&delegations=' + delegations,// + '&sort=' + order,
    headers: getHeaders(true),
  })
const getById = (id) =>
  axios({
    method: 'get',
    url: `${url}/${id}`,
    headers: getHeaders(true),
  })
const remove = (id) =>
  axios({
    method: 'delete',
    url: `${url}/${id}`,
    headers: getHeaders(true),
  })
const put = (id, resource) =>
  axios({
    method: 'put',
    url: `${url}/${id}`,
    headers: getHeaders(true),
    data: resource
  })

export default { post, get, getById, remove, put }
